import React from "react";
import "./Heading.css";
import { ChevronLeft } from "lucide-react";

export const PageHeading = ({ title, subTitle }) => {
  return (
    <div className="ko-heading">
      <h1 className="ko-heading__title page-title">
        {title ? title : "Page Heading"}
      </h1>
      {subTitle && (
        <p className="ko-heading__subtitle page-sub-title">{subTitle}</p>
      )}
    </div>
  );
};

export const SectionHeading = ({ title, subTitle }) => {
  return (
    <div className="ko-heading">
      <h2 className="ko-heading__title section-title ">
        {title ? title : "Section Heading"}
      </h2>
      {subTitle && (
        <p className="ko-heading__subtitle section-sub-title">{subTitle}</p>
      )}
    </div>
  );
};

export const Heading = ({ title, subTitle, size = "lg", onBack }) => {
  return (
    <div className={`ko-heading ko-heading--${size} custom-heading`}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          marginBottom: subTitle ? "0.25rem" : 0,
        }}
      >
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.25rem",
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 0,
              color: "inherit",
              fontSize: "1rem",
              fontWeight: 500,
            }}
          >
            <ChevronLeft size={18} />
          </button>
        )}

        <h1 className="ko-heading__title" style={{ margin: 0 }}>
          {title || "Heading"}
        </h1>
      </div>

      {subTitle && (
        <p className="ko-heading__subtitle heading-sub-title">{subTitle}</p>
      )}
    </div>
  );
};
